module.exports = __webpack_public_path__ + "img/add-image.b8676f79.svg";